/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_ColorInputs */



/**
* | output |
* | --- |
* | "Insert speaker color" |
*
* @param {Insert_Speaker_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_color = /** @type {((inputs?: Insert_Speaker_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer la couleur de l'intervenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecherfarbe einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il colore dell'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте цвет динамика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar color del altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入扬声器颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの色を挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर का रंग डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir cor do alto-falante")
	return /** @type {LocalizedString} */ ("Insert speaker color")
});